import { useIsCompactCustomizeBar } from '@/hooks/useIsBreakpoint';
import { Button, Icon } from '@/ui';

type Props = {
  onClick: () => void;
};

// Returns to the customize home card list. Collapses to the chevron alone once
// the bar is crowded — matching ViewKeyToggle in the platform bar below it.
export const BackToAllButton = ({ onClick }: Props) => {
  const isCompact = useIsCompactCustomizeBar();

  if (isCompact) {
    return (
      <Button
        aria-label="All"
        mr={1}
        px="0"
        size="ah-sm"
        variant="ahGhost"
        onClick={onClick}
      >
        <Icon icon="ChevronLeft" size={4} />
      </Button>
    );
  }

  return (
    <Button
      leftIcon={<Icon icon="ChevronLeft" size={4} />}
      mr={1}
      size="ah-sm"
      variant="ahGhost"
      onClick={onClick}
    >
      All
    </Button>
  );
};
